import { render, staticRenderFns } from "./FeatureSelector.vue?vue&type=template&id=65451895"
import script from "./FeatureSelector.vue?vue&type=script&lang=js"
export * from "./FeatureSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports